module.exports = __webpack_public_path__ + "static/media/IA.b787400e.png";